const features = [
  { icon: 'ri-search-eye-line', title: 'Expert Exploration', desc: 'We dig deep into every Roblox world to find what others miss' },
  { icon: 'ri-gamepad-line', title: 'Gaming Community', desc: 'Thousands of players sharing and discovering secrets together' },
  { icon: 'ri-flashlight-line', title: 'Weekly Updates', desc: 'Fresh secrets and discoveries added every single week' },
];

export default function AboutSection() {
  return (
    <section id="about" className="bg-[#0a0a0f] py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-12 md:gap-16">
          {/* Left - Visual */}
          <div className="w-full lg:w-2/5 flex items-center justify-center">
            <div className="relative w-64 h-64 md:w-80 md:h-80">
              {/* Outer glow ring */}
              <div
                className="absolute inset-0 rounded-full animate-pulse"
                style={{ background: 'radial-gradient(ellipse, rgba(168,85,247,0.3) 0%, transparent 70%)', filter: 'blur(20px)' }}
              />
              {/* Inner circle */}
              <div
                className="absolute inset-8 rounded-full border-2 border-purple-500/40 flex items-center justify-center"
                style={{ background: 'rgba(168,85,247,0.08)' }}
              >
                <div
                  className="absolute inset-4 rounded-full border border-yellow-400/20 flex items-center justify-center"
                  style={{ background: 'rgba(250,204,21,0.05)' }}
                >
                  <div className="w-20 h-20 flex items-center justify-center">
                    <i
                      className="ri-eye-line text-yellow-400"
                      style={{ fontSize: '5rem', filter: 'drop-shadow(0 0 20px rgba(250,204,21,0.8))' }}
                    ></i>
                  </div>
                </div>
              </div>
              {/* Floating icons */}
              {[
                { icon: 'ri-lock-2-line', top: '5%', left: '10%', color: '#a855f7' },
                { icon: 'ri-alert-line', top: '10%', right: '5%', color: '#facc15' },
                { icon: 'ri-map-2-line', bottom: '10%', left: '5%', color: '#facc15' },
                { icon: 'ri-flashlight-line', bottom: '5%', right: '10%', color: '#a855f7' },
              ].map((item, i) => (
                <div
                  key={i}
                  className="absolute w-10 h-10 flex items-center justify-center rounded-full border border-purple-700/40"
                  style={{
                    top: item.top,
                    left: item.left,
                    right: item.right,
                    bottom: item.bottom,
                    background: 'rgba(168,85,247,0.1)',
                    animation: `float ${3 + i * 0.5}s ease-in-out infinite`,
                    animationDelay: `${i * 0.7}s`,
                  }}
                >
                  <i className={`${item.icon} text-lg`} style={{ color: item.color, filter: `drop-shadow(0 0 6px ${item.color})` }}></i>
                </div>
              ))}
            </div>
          </div>

          {/* Right - Content */}
          <div className="w-full lg:w-3/5">
            <div
              className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-purple-500/50 mb-5"
              style={{ background: 'rgba(168,85,247,0.12)' }}
            >
              <i className="ri-information-line text-yellow-400 text-sm"></i>
              <span className="text-yellow-400 text-xs font-black uppercase tracking-widest">About Us</span>
            </div>

            <h2
              className="font-black text-white text-3xl md:text-4xl mb-5"
              style={{ textShadow: '0 0 20px rgba(168,85,247,0.5)', fontFamily: "'Orbitron', sans-serif" }}
            >
              Roblox Secrets
            </h2>

            <p className="text-gray-300 text-base md:text-lg leading-relaxed mb-8">
              Roblox Secrets is a mystery gaming brand where we explore hidden worlds, secret rooms and unexpected discoveries inside Roblox. We go where no player has gone before — uncovering the mysteries that developers left behind.
            </p>

            <div className="flex flex-col gap-4">
              {features.map((f) => (
                <div
                  key={f.title}
                  className="flex items-start gap-4 p-4 rounded-xl border border-purple-800/30 transition-all duration-200 hover:border-purple-600/50"
                  style={{ background: 'rgba(168,85,247,0.05)' }}
                >
                  <div
                    className="w-10 h-10 flex items-center justify-center rounded-lg shrink-0"
                    style={{ background: 'rgba(250,204,21,0.1)', border: '1px solid rgba(250,204,21,0.25)' }}
                  >
                    <i className={`${f.icon} text-yellow-400 text-xl`}></i>
                  </div>
                  <div>
                    <h4 className="text-white font-bold text-sm mb-0.5">{f.title}</h4>
                    <p className="text-gray-500 text-sm">{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
      `}</style>
    </section>
  );
}
